// video popup//

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".step-media").forEach(function (preview) {
    preview.addEventListener("click", function () {
      const popupId = preview.getAttribute("data-video-id");
      const popup = document.getElementById(popupId);
      if (!popup) return;
      popup.classList.remove("hidden");

      const video = popup.querySelector("video");
      if (video) {
        video.play();

        video.onended = function () {
          video.pause();
          video.currentTime = 0;
          popup.classList.add("hidden");
        };
      }
    });
  });

  document.querySelectorAll(".video-popup .close-btn").forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      event.stopPropagation();
      const popup = btn.closest(".video-popup");
      const video = popup.querySelector("video");
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.onended = null;
      }
      popup.classList.add("hidden");
    });
  });
});
// document.addEventListener('DOMContentLoaded', function () {
//   var splide = new Splide('#splide__brand_slide', {
//     type: 'loop',
//     perPage: 5,
//     pagination: false,
//     arrows: false,
//     autoplay: true,
//     gap: '1rem',
//     breakpoints: {
//       1024: { perPage: 4 },
//       768: { perPage: 3 },
//       480: { perPage: 2 }
//     }
//   });
//   splide.mount();
// });
document.addEventListener("DOMContentLoaded", function () {
  let splideEl = document.getElementById("splide__brand_slide");
  if (splideEl) {
    let splide = new Splide(splideEl, {
      type: "loop",
      perPage: 5,
      pagination: false,
      arrows: false,
      autoplay: true,
      gap: "1rem",
      breakpoints: {
        1024: { perPage: 4 },
        768: { perPage: 3 },
        480: { perPage: 2 },
      },
    });
    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll(".related_prod_slide").forEach(function (slider) {
      if (!slider.classList.contains("splide-initialized")) {
        new Splide(slider, {
          type: "loop",
          perPage: 4,
          perMove: 1,
          gap: "1rem",
          arrows: true,
          pagination: false,
          breakpoints: {
            1024: { perPage: 3 },
            768: { perPage: 2 },
            480: { perPage: 1 },
          },
        }).mount();
        slider.classList.add("splide-initialized");
      }
    });
  });

  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);
});

document.addEventListener("DOMContentLoaded", function () {
  const faqAns = document.querySelector('.faq_ans');
  if (faqAns) {
    faqAns.innerHTML = faqAns.innerHTML.replace(/<br\s*\/?>/gi, '');
  }
});
